<div class="circleImageSmall" [ngClass]="disabled ? 'disabled':'enabled'">
    <div class="iconFont">{{initials | uppercase}}</div>
</div>